import { AsyncResponseBase } from "abweb/dto/generated/async/AsyncResponseBase";
export class AsyncResponse extends AsyncResponseBase {
  static createAsyncResponse(canceled, done, error, messages, response, taskId) {
    const retVal = new AsyncResponse();
    retVal.initAsyncResponse(canceled, done, error, messages, response, taskId);
    return retVal;
  }
  constructor() {
    super();
  }
  set deserializeContext(parentContext) {
    this._deserializeContext = parentContext;
  }
  finish(responseParser, messageParsers) {
    if (messageParsers) {
      for (let i = 0; i < this.messages.length; i++) {
        if (messageParsers[this.messages[i].queueName]) {
          this.messages[i].message = messageParsers[this.messages[i].queueName].parse(this.messages[i].message, this._deserializeContext);
        }
      }
    }
    if (this.response && responseParser) {
      this.response = responseParser.parse(this.response, this._deserializeContext);
    }
  }
}
//# sourceMappingURL=AsyncResponse.js.map
